var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0a8552;}.b{fill:#003c71;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-450 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(450 524)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.057 528.948)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.537,46.8c2.514,5.914,8.347,11.828,18.644,11.828S52.444,53.582,55.826,46.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.799,
    cy: 4.983,
    rx: 3.799,
    ry: 4.983,
    transform: "translate(21.889 27.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.799,
    cy: 4.983,
    rx: 3.799,
    ry: 4.983,
    transform: "translate(44.876 27.023)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/level1.176e3844b912e44b9fb10db514399d4f.svg";
export { ForwardRef as ReactComponent };